import { type Options, useSearch } from '@dhl/search'
import { type Servicepoint } from './model.js'

export const useServicepointSearch = (
  servicepoints: Servicepoint[],
  options?: Options<Servicepoint>
): ReturnType<typeof useSearch<Servicepoint>> =>
  useSearch({
    searchableItems: servicepoints ?? [],
    searchKeys: ['name', 'address.city', 'address.street', 'address.houseNumber', 'address.postalCode'],
    options,
  })
